import { NavLink } from "react-router-dom";
import { formatAstrologerPrice } from "../../api/astrologerApi";
import fallbackAstrologerImage from "../../assets/images/astrologer.png";

export default function AstrologerCard({
  astrologer,
  actionLabel,
  actionTo,
  online = false,
  className = "",
}) {
  const detailPath = `/astrologer/${astrologer.id}`;
  const ctaPath = actionTo || detailPath;
  const ctaText = actionLabel || astrologer.ctaLabel || "Book a Consultation";
  const rawPrice = Number(astrologer.pricePerMin);
  const hasPrice = Number.isFinite(rawPrice) && rawPrice > 0;
  const imageSrc = astrologer.image || fallbackAstrologerImage;

  return (
    <article
      className={`astro-card second-bg d-flex flex-column h-100 ${className}`}
    >
      <NavLink
        to={detailPath}
        state={astrologer}
        className="astro-card__link no-underline text-reset"
      >
        <div className="astro-card__media position-relative">
          <img
            src={imageSrc}
            alt={astrologer.name}
            className="astro-card__image"
            onError={(event) => {
              event.currentTarget.onerror = null;
              event.currentTarget.src = fallbackAstrologerImage;
            }}
          />
          {online && <span className="astro-card__online">online</span>}
        </div>

        <div className="astro-card__body d-flex flex-column flex-grow-1">
          <div className="astro-card__header d-flex justify-content-between gap-2">
            <h3 className="astro-card__name text-lora mb-0">{astrologer.name}</h3>
            <div className="astro-card__price text-end flex-shrink-0">
              <strong className="astro-card__price-value">
                {hasPrice ? `₹${formatAstrologerPrice(rawPrice)}` : "-"}
              </strong>
              <small className="astro-card__price-unit d-block">Per Min</small>
            </div>
          </div>

          <div className="astro-card__meta">
            {astrologer.specialty && <p className="mb-0">{astrologer.specialty}</p>}
            <p className="mb-0">
              Language : {astrologer.language || "Hindi, English"}
            </p>
            {astrologer.experience && (
              <p className="mb-0">{astrologer.experience}</p>
            )}
          </div>
        </div>
      </NavLink>

      <NavLink
        to={ctaPath}
        state={astrologer}
        className="first-btn text-center no-underline mt-auto"
      >
        {ctaText}
      </NavLink>
    </article>
  );
}
